import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { PhoneNumberWorkflows } from '../services/auth.types';

export const PhoneNumberActions = createActionGroup({
  source: 'User Account Page Phone Number',
  events: {
    'Start Update Workflow': props<{ phoneNumber: string; workflow: PhoneNumberWorkflows }>(),
    'Check Blacklist': props<{ phoneNumber: string; workflow: PhoneNumberWorkflows }>(),
    'Is Blacklisted': props<{ phoneNumber: string; workflow: PhoneNumberWorkflows }>(),
    'Update Person': props<{ phoneNumber: string; workflow: PhoneNumberWorkflows }>(),
    'Update Person Success': props<{ phoneNumber: string; workflow: PhoneNumberWorkflows }>(),
    'Update Person Error': props<{ error: unknown; workflow: PhoneNumberWorkflows }>(),
    'Update Cognito Success': props<{ phoneNumber: string; workflow: PhoneNumberWorkflows }>(),
    'Update Cognito Error': props<{ error: unknown; workflow: PhoneNumberWorkflows }>(),

    'Send Verification': props<{ workflow: PhoneNumberWorkflows; isResend: boolean }>(),
    'Verification Code Sent': props<{ workflow: PhoneNumberWorkflows; isResend: boolean }>(),
    'Verification Code Sent Error': props<{ error: unknown; workflow: PhoneNumberWorkflows }>(),
    'Verify SMS Code For MFA': props<{ confirmationCode: string; workflow: PhoneNumberWorkflows }>(),
    'MFA Cancelled': emptyProps(),

    'Check Is Robot': props<{ workflow: PhoneNumberWorkflows }>(),
    'Show Recaptcha': props<{ token: string; workflow: PhoneNumberWorkflows }>(),
    'Recaptcha Success': props<{ workflow: PhoneNumberWorkflows }>(),
    'Recaptcha Error': props<{ error: unknown; workflow: PhoneNumberWorkflows }>(),

    'Open Confirmation Dialog': props<{ workflow: PhoneNumberWorkflows }>(),
    'Submit Confirmation Code': props<{ code: string; workflow: PhoneNumberWorkflows }>(),
    'Cancel Confirmation': emptyProps(),
    'Confirmation Code Confirmed': props<{ workflow: PhoneNumberWorkflows }>(),
    'Confirmation Code Error': props<{ error: unknown; workflow: PhoneNumberWorkflows }>(),
  },
});
